import { SUPPORTED_LANGUAGES } from '@/shared/config';
import type { Language } from '@/shared/types';
import { Navigate, Outlet, useParams } from 'react-router-dom';

export const LocaleGuard = () => {
  const { locale } = useParams();

  if (locale && !SUPPORTED_LANGUAGES.includes(locale as Language)) {
    return <Navigate to="*" replace />;
  }

  return <Outlet />;
};
